import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function SnackWarningSection() {
  return <section className="bg-[#1f2e10] text-white py-14 md:py-16 px-4 border-y border-[#c4f000]/20" data-id="element-180">
      <div className="max-w-3xl mx-auto text-center" data-id="element-181">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-[#c4f000] mb-8 leading-tight" data-id="element-182">
          Tuo figlio fa merenda centinaia di volte ogni anno.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-gray-300 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-183">
          Offrirgli sempre biscotti confezionati, patatine o succhi industriali
          può influire sulle sue abitudini alimentari, sulla concentrazione e
          sull'energia.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 mb-2 max-w-2xl mx-auto" data-id="element-184">
          Non è perché non ti importa.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-185">
          Semplicemente non hai tempo per preparare tutto da zero ogni giorno.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-xl md:text-2xl font-bold text-white mb-3 max-w-2xl mx-auto" data-id="element-186">
          Per questo è nato Merende Felici.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-187">
          Oltre 200 ricette sane, veloci e amate dai bambini, pronte in meno di
          15 minuti.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} data-id="element-188">
          <CTAButton href="#pricing" data-id="element-189">
            VOGLIO SCOPRIRE MERENDE FELICI™
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}